import React from "react";
import { useHistory, useLocation } from "react-router-dom";

const AREAS = [
  { key: "dashboard", label: "Dashboard", path: "/playbooks/dashboard" },
  { key: "playbooks", label: "Playbooks", path: "/playbooks" },
  { key: "sessions", label: "Sessions", path: "/playbooks/sessions" },
  { key: "reports", label: "Reports", path: "/playbooks/reports" },
  { key: "administration", label: "Admin", path: "/playbooks/administration" },
];

function activeArea(pathname) {
  if (pathname.startsWith("/playbooks/sessions")) return "sessions";
  if (pathname.startsWith("/playbooks/dashboard")) return "dashboard";
  if (pathname.startsWith("/playbooks/reports")) return "reports";
  if (pathname.startsWith("/playbooks/administration")) return "administration";
  return "playbooks";
}

export default function IrShell({ children }) {
  const history = useHistory();
  const location = useLocation();
  const current = activeArea(location.pathname);

  return (
    <div className="ir-shell">
      <div className="ir-shell-head">
        <div className="ir-shell-brand">
          <p className="ir-shell-eyebrow">Operations</p>
          <div className="ir-shell-title">Incident Response</div>
        </div>
        <nav className="ir-shell-nav" aria-label="Incident Response areas">
          {AREAS.map((a) => (
            <button
              key={a.key}
              type="button"
              className={`ir-shell-tab ${current === a.key ? "active" : ""}`}
              onClick={() => history.push(a.path)}
              aria-current={current === a.key ? "page" : undefined}
            >
              {a.label}
            </button>
          ))}
        </nav>
      </div>
      <div className="ir-shell-body">{children}</div>
    </div>
  );
}
